









































import { Component, Prop, Vue } from "vue-property-decorator";
import UriPreview from "@/components/UriPreview.vue";

@Component({
  components: { UriPreview },
})
/**
 * View after proposing a cpt for moderation
 */
export default class ProposedCPT extends Vue {
  /**
   * The identifier/name of the custom post type
   */
  @Prop({ required: true, type: String }) readonly cpt!: string;

  /**
   * The id of the current contribution
   */
  @Prop({ required: true, type: String }) readonly id!: string;
}
